// Session-scoped storage for support "view as user" mode. Dependency-free on
// purpose: the DatabaseAPI client reads the active email from here to stamp
// `impersonate` on every request without importing auth modules (no cycles).
//
// This is UX plumbing only — the server (SideNerdApps auth_middleware.py)
// re-validates every impersonated request: internal-role actors, read-only
// operation allowlist, target resolved from the user pool, audit-logged.

export interface ViewAsTarget {
  email: string;
  name?: string;
  project_string: string;
  client?: string;
  role?: string;
  billing?: string;
  default_app?: string;
}

const KEY = "sn-view-as";

export function getViewAs(): ViewAsTarget | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ViewAsTarget;
    return parsed.email && parsed.project_string ? parsed : null;
  } catch {
    return null;
  }
}

export function setViewAs(target: ViewAsTarget): void {
  sessionStorage.setItem(KEY, JSON.stringify(target));
}

export function clearViewAs(): void {
  sessionStorage.removeItem(KEY);
}

/** Email to stamp as `impersonate` on DatabaseAPI requests (null = off). */
export function getViewAsEmail(): string | null {
  return getViewAs()?.email ?? null;
}
